
import * as React from 'react';
import configData from "../config.json";

import { RouteComponentProps } from 'react-router';
import {
    Card, CardHeader, CardBody, Row, Col, FormGroup,
    Label, Input, Button, CustomInput
} from 'reactstrap';

import { alertService } from 'components/Varios/alert_service.js';

import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'

import SelectItem from "components/Varios/select.js";
import Datepicker from "components/Varios/Datepicker.js";
import CardCapacitaciones from "components/Varios/CardCapacitaciones.js";

import FileUpload from "components/Varios/FileUpload.js";
import FileDownload from "components/Varios/FileDownload.js";

import InputFileDownload from "components/Varios/InputFileDownload.js";
import InputFileUpload from "components/Varios/InputFileUpload.js";

import { authenticationService } from '../services/authentication.service';
import { mensajeCamposIncompletos } from './constants';

const id = 1043;
const API_URL = configData.SERVER_URL

export class CapacitacionesData {
    idcapacitacion: number = 0;
    idpersona: number = 0;
    idpais: number = 0;
    tipoevento: number = 0;
    duracion: number = 0;

    nombre: string = "";
    formaconocim: string = "";
    fechainicio: string = "";
    fechafin: string = "";

    tipomodalidad: string = "";

    refarchivo1: string = "";

    modulo: string = "D";

    tipocertificado: string | undefined = undefined;
    certificadopor: string = "";
    idtipoconocimien: number | undefined = -1;
}

interface CapacitacionesDataState {
    currentUser: any,
    loading: boolean;
    loadingList: boolean;
    dtoData: CapacitacionesData;
    CapacitacionesImpartidasDataList: CapacitacionesData[];
    CapacitacionesRecibidasDataList: CapacitacionesData[];
    rolList: Array<any>;
    tipoList: Array<any>;
    paisList: Array<any>;
    error: null;
    tiposEvidencia: Array<any>;
    filesData: Array<any>;
    tipoCertificadoList: Array<{ value: string, label: string }>,
    tipoConocimientoList: Array<{ value: string, label: string }>
}

export class Capacitaciones extends React.Component<RouteComponentProps<{}>, CapacitacionesDataState> {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: authenticationService.currentUserValue, loading: false, loadingList: true,
            dtoData: new CapacitacionesData(), CapacitacionesImpartidasDataList: [], CapacitacionesRecibidasDataList: [],
            rolList: [], tipoList: [], paisList: [], error: null, tiposEvidencia: [], filesData: [],
            tipoCertificadoList: [
                {
                    value: "AP",
                    label: "Aprobación"
                },
                {
                    value: "AS",
                    label: "Asistencia"
                }
            ],
            // dtdatos.Rows.Add("0", "Ninguno");
            // dtdatos.Rows.Add("1", "Andragógico/Pedagógico");
            // dtdatos.Rows.Add("2", "Actualización Profesional");
            // dtdatos.Rows.Add("3", "Investigación");
            tipoConocimientoList: [

                {
                    value: "1",
                    label: "Pedagógico"
                }
                ,{
                    value: "2",
                    label: "Científico/Profesional"
                }
                //,{
                //    value: "3",
                //    label: "Investigación"
                //}
                ,{
                    value: "4",
                    label: "Otros"
                }
            ]
        };

        this.cargarDatos = this.cargarDatos.bind(this);
        this.cargarCapacitaciones = this.cargarCapacitaciones.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleFileUploadChange = this.handleFileUploadChange.bind(this);
    }

    componentDidMount() {
        authenticationService.currentUser.subscribe(
            (x) => {
                this.setState({
                    currentUser: x
                });
                if (x && x.token) {
                    this.cargarDatos();
                    this.cargarCapacitaciones();
                }
            }
        );

    }

    cargarDatos() {
        //API PARA OBTENER PAISES
        fetch(API_URL + "DatosEscalafon/Paises")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            paisList: result.entTabla.map(d => ({
                                "value": d.idpais,
                                "label": d.nombre
                            })),
                        });
                    } else {
                        alertService.error("Ocurrió un error al obtener los paises.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        paisList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        //API PARA OBTENER ROLES
        fetch(API_URL + "DatosCapacitacion/Rol")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            rolList: result.entTabla.map(d => ({
                                "value": d.codigostr.trim(),
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        alertService.error("Ocurrió un error al obtener los roles.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        rolList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        // API PARA OBTENER NIVEL DE TIPOS
        fetch(API_URL + "DatosCapacitacion/TipoEventoCapacitacion")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            tipoList: result.entTabla.map(d => ({
                                "value": d.codigo,
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        alertService.error("Ocurrió un error al obtener los tipos.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        tipoList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }
    //API PARA OBTENER INFORMACIÓN ACADÉMICA DE PERSONA
    cargarCapacitaciones() {
        fetch(API_URL + "DatosCapacitacion/CapacitacionByTipoIdPersonaDesc/R/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            CapacitacionesRecibidasDataList: result.entTabla,
                            tiposEvidencia: this.cargarEvidencias(null)
                        });


                    } else {
                        alertService.error("Ocurrió un error al obtener las capacitaciones.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        CapacitacionesRecibidasDataList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
        fetch(API_URL + "DatosCapacitacion/CapacitacionByTipoIdPersonaDesc/I/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            CapacitacionesImpartidasDataList: result.entTabla,
                            loadingList: false,
                            tiposEvidencia: this.cargarEvidencias(null)
                        });


                    } else {
                        alertService.error("Ocurrió un error al obtener las capacitaciones.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        CapacitacionesImpartidasDataList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

    }

    handleChange(event) {
        var dto = this.state.dtoData;
        dto[event.target.name] = event.target.value;
        this.setState({
            dtoData: dto,
            loading: false
        })
    }

    handleSelectChange(value, name) {
        var dto = this.state.dtoData;
        if (typeof (dto[name]) === "number") {
            dto[name] = +value;

        }
        else {
            dto[name] = value;

        }
        this.setState({ dtoData: dto });
    }

    handleFileUploadChange(tipoEvidencia, uploadFile) {
        const src = window.URL.createObjectURL(uploadFile);
        const fileInfo = { type: tipoEvidencia, file: uploadFile, id: tipoEvidencia, src: src };
        let fileInfoState = this.state.filesData.slice();
        let fileInfoStateFiltrado = fileInfoState.filter(f => f.type !== fileInfo.type);
        fileInfoState = fileInfoStateFiltrado.concat(fileInfo);

        this.setState({
            filesData: fileInfoState,
        });

    }

    cargarEvidencias(tipoEvidencia) {
        var tiposEvidencia = [{ "value": "EAC", "label": "Certificado de capacitación" }];
        return tiposEvidencia;
    }

    descargarEvidencias(capacitacion: CapacitacionesData) {
        var evidencias = new Array();
        if (capacitacion.refarchivo1) {
            evidencias.push({ name: "EAC" + capacitacion.idpersona + ".PDF", url: API_URL + "DatosCapacitacion/Refarchivo/EAC/" + capacitacion.idcapacitacion });
        }
        return evidencias;
    }

    onClickLimpiar() {
        this.setState({ dtoData: new CapacitacionesData(), filesData: [], });
    }

    onClickEdit(idcapacitacion) {
        //API PARA OBTENER TELEFONOS DE PERSONA
        fetch(API_URL + "DatosCapacitacion/CapacitacionById/" + idcapacitacion)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            dtoData: result.entTabla[0],
                            tiposEvidencia: this.cargarEvidencias(null),
                            loading: false
                        });

                        let myDiv = document.getElementById('main-panel')!;
                        myDiv.scrollTo(0, 0);

                    } else {
                        alertService.error(result["strMensaje"])
                    }

                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        dtoData: new CapacitacionesData()
                    });
                    alertService.error("Ocurrió un error")
                }
            )
    }

    onClickDelete(idcapacitacion) {
        fetch(API_URL + "FormularioController/DeleteDatosCapacitacion/" + idcapacitacion, {

            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },

        })
            .then(response => response.json())
            .then(
                (responseJson) => {
                    if (responseJson["strEstado"] === "N") {
                        alertService.error(responseJson["strMensaje"])
                    }
                    else {
                        alertService.success("La capacitación se eliminó correctamente.")
                        authenticationService.updateUltimoCambioCurrentUserValue(new Date().toISOString())
                        this.cargarCapacitaciones();
                    }
                })
    }

    private handleSave(event) {

        //type PropType<TObj, TProp extends keyof TObj> = TObj[TProp];        
        event.preventDefault();
        const forma = new FormData(event.target);
        var dto = this.state.dtoData;
        var filesData = this.state.filesData;
        let formIsValid = true;

        if ((filesData === undefined || filesData.length === 0) && !dto.refarchivo1) {
            alertService.error("Debe adjuntar evidencia de su capacitación")
            return;
        }

        if (dto['fechainicio'] > dto['fechafin']) {
            alertService.error("Error: La fecha de inicio debe ser menor a la fecha de fin.");
            return;
        }

        forma.forEach((value, clave) => {

            // if (!value && clave !== "evidencias" && clave !== "certificadopor") {
            if (!value) {
                if (dto.tipomodalidad === "L") {
                    if (clave !== "idpais") {
                        formIsValid = false;
                    }
                }
                else {
                    formIsValid = false;
                }

            }

            if (typeof dto[clave] === 'number') {
                dto[clave] = Number(value);
            }
            else if (typeof dto[clave] === 'boolean') {
                dto[clave] = Boolean(value);
            }
            else
                dto[clave] = value;
            if (clave === 'duracion') dto[clave] = Number(value);
            if (clave === 'fechainicio' || clave === 'fechafin') {
                value = String(value)
                var info = value.split('/').reverse().join('-');
                var date = new Date(String(info))
                dto[clave] = date.toJSON();
            }

        });

        if (dto.tipomodalidad === "") {
            formIsValid = false;
        }

        if ((dto["formaconocim"] !== "R" && dto["formaconocim"] !== "E")) {
            dto.tipocertificado = undefined;
            dto.idtipoconocimien = undefined;
        }

        dto.idpersona = this.state.currentUser.idpersona;

        const data = JSON.stringify({
            "tcapacitacion": dto,
        });

        if (formIsValid) {
            if (dto.idcapacitacion === 0) {
                fetch(API_URL + "FormularioController/PostDatosCapacitacion", {

                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,

                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error(mensajeCamposIncompletos())
                            }
                            else if (responseJson["strEstado"] === "S") {

                                authenticationService.updateUltimoCambioCurrentUserValue(new Date().toISOString())

                                if (filesData.length > 0) {
                                    var formFilesData = new FormData();

                                    filesData.map((fileData) => {
                                        formFilesData.append(fileData.type, fileData.file, fileData.file.name);
                                    });

                                    formFilesData.append('idcapacitacion', responseJson.tcapacitacion.idcapacitacion);

                                    fetch(API_URL + "FormularioController/PostFilesDatosCapacitacion", {
                                        method: 'POST',
                                        body: formFilesData
                                    })
                                        .then(response => response.json())
                                        .then(
                                            (responseJson) => {
                                                if (responseJson["strEstado"] === "S") {
                                                    alertService.success("La capacitación se ha registrado correctamente.");
                                                    this.onClickLimpiar();
                                                    this.cargarCapacitaciones();
                                                }
                                                else {
                                                    alertService.error(responseJson["strMensaje"])
                                                }
                                            })
                                        .catch(error => alertService.error(error)
                                        );
                                }
                                else {
                                    alertService.success("La capacitación se ha registrado correctamente.");
                                    this.onClickLimpiar();
                                    this.cargarCapacitaciones();
                                }
                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }
                        })
            }
            else {
                fetch(API_URL + "FormularioController/PutDatosCapacitacion", {

                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,

                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error(responseJson["strMensaje"])
                            }
                            else if (responseJson["strEstado"] === "S") {

                                authenticationService.updateUltimoCambioCurrentUserValue(new Date().toISOString())

                                if (filesData.length > 0) {
                                    var formFilesData = new FormData();

                                    filesData.map((fileData) => {
                                        formFilesData.append(fileData.type, fileData.file, fileData.file.name);
                                    });

                                    formFilesData.append('idcapacitacion', responseJson.tcapacitacion.idcapacitacion);

                                    fetch(API_URL + "FormularioController/PostFilesDatosCapacitacion", {
                                        method: 'POST',
                                        body: formFilesData
                                    })
                                        .then(response => response.json())
                                        .then(
                                            (responseJson) => {
                                                if (responseJson["strEstado"] === "S") {
                                                    alertService.success("La capacitación se ha actualizado correctamente.");
                                                    this.onClickLimpiar();
                                                    this.cargarCapacitaciones();
                                                }
                                                else {
                                                    alertService.error(responseJson["strMensaje"])
                                                }
                                            })
                                        .catch(error => alertService.error(error)
                                        );
                                }
                                else {
                                    alertService.success("La capacitación se ha actualizado correctamente.");
                                    this.onClickLimpiar();
                                    this.cargarCapacitaciones();
                                }
                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }
                        })
            }
        }
        else {
            alertService.error(mensajeCamposIncompletos());
        }
    }

    public render() {

        let contents = this.state.loading

            ?
            <div style={{ textAlign: "center" }}>
                <i className="fas fa-sync fa-spin"></i>
                <em> Cargando</em>

            </div>

            : this.renderForm(this.state.CapacitacionesRecibidasDataList, this.state.CapacitacionesImpartidasDataList,
                this.state.rolList, this.state.tipoList, this.state.paisList, this.state.tiposEvidencia);
        return <div className="content">

            {contents}

        </div>;

    }

    // Returns the HTML Form to the render() method.  

    private renderForm(CapacitacionesRecibidasDataList: Array<any>, CapacitacionesImpartidasDataList: Array<any>,
        rolList: Array<any>, tipoList: Array<any>, paisList: Array<any>, tiposEvidencia: Array<any>) {

        return (
            <>
                <Row>
                    <Col md={12}>
                        <Card className="principal">
                            <CardHeader>
                                <h5 className="title">CAPACITACIONES</h5>
                            </CardHeader>
                            <CardBody className="main-content">
                                <div>
                                    <form onSubmit={this.handleSave} autoComplete ="off">
                                        <Row form>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Label for="nombre">Nombre del curso/congreso/taller/seminario/etc*</Label>
                                                    <Input maxLength="300" name="nombre" id="nombre" value={this.state.dtoData.nombre} onChange={this.handleChange} required />
                                                </FormGroup>
                                            </Col>
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="tipoevento">Tipo*</Label>
                                                    <SelectItem
                                                        options={tipoList}
                                                        value={this.state.dtoData.tipoevento}
                                                        onChange={this.handleSelectChange}
                                                        placeholder=""
                                                        name="tipoevento"
                                                        id="tipoevento"
                                                        icon="fa-caret-right"
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="formaconocim">Rol*</Label>
                                                    <SelectItem
                                                        options={rolList}
                                                        value={this.state.dtoData.formaconocim ? this.state.dtoData.formaconocim.trim() : ""}
                                                        onChange={this.handleSelectChange}
                                                        placeholder=""
                                                        name="formaconocim"
                                                        id="formaconocim"
                                                        icon="fa-caret-right"
                                                    />
                                                </FormGroup>
                                            </Col>



                                        </Row>
                                        {

                                            <Row form >


                                                {
                                                    this.state.dtoData["formaconocim"] &&
                                                    (this.state.dtoData["formaconocim"].trim() === "R" || this.state.dtoData["formaconocim"].trim() === "E")
                                                    &&
                                                    <React.Fragment>
                                                        <Col md={3}>
                                                            <FormGroup>
                                                                <Label for="tipocertificado">Tipo Certificado*</Label>
                                                                <SelectItem
                                                                    options={this.state.tipoCertificadoList}
                                                                    value={this.state.dtoData.tipocertificado ? this.state.dtoData.tipocertificado.trim() : ""}
                                                                    onChange={this.handleSelectChange}
                                                                    placeholder=""
                                                                    name="tipocertificado"
                                                                    id="tipocertificado"
                                                                    icon="fa-caret-right"
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md={3}>
                                                            <FormGroup>
                                                                <Label for="idtipoconocimien">Tipo Conocimiento*</Label>
                                                                <SelectItem
                                                                    options={this.state.tipoConocimientoList}
                                                                    value={this.state.dtoData.idtipoconocimien ? this.state.dtoData.idtipoconocimien.toString().trim() : ""}
                                                                    onChange={this.handleSelectChange}
                                                                    placeholder=""
                                                                    name="idtipoconocimien"
                                                                    id="idtipoconocimien"
                                                                    icon="fa-caret-right"
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                    </React.Fragment>

                                                }

                                            </Row>
                                        }
                                        <Row form>

                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="tipoidentificacion">Modalidad*</Label>
                                                    <Row>
                                                        <Col md={5}>
                                                            <CustomInput
                                                                className="col-md-5 ml-1"
                                                                type="radio"
                                                                checked={this.state.dtoData.tipomodalidad === "P"}
                                                                value="P"
                                                                id="modalidad"
                                                                name="tipomodalidad"
                                                                onChange={this.handleChange}
                                                                label="Presencial"
                                                            />
                                                        </Col>
                                                        <Col md={5}>
                                                            <CustomInput
                                                                className="col-md-6"
                                                                type="radio"
                                                                value="L"
                                                                id="modalidad2"
                                                                name="tipomodalidad"
                                                                checked={this.state.dtoData.tipomodalidad === "L"}
                                                                onChange={this.handleChange}
                                                                label="Virtual"
                                                            />
                                                        </Col>
                                                    </Row>

                                                </FormGroup>
                                            </Col>
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="idpais">País{this.state.dtoData.tipomodalidad === "P" ? "*" : ""}</Label>
                                                    <SelectItem
                                                        options={paisList}
                                                        value={this.state.dtoData.idpais}
                                                        onChange={this.handleSelectChange}
                                                        placeholder=""
                                                        name="idpais"
                                                        id="idpais"
                                                        icon="pais"
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={2}>
                                                <FormGroup>
                                                    <Label for="fechainicio">Fecha inicio*</Label>
                                                    <Datepicker
                                                        value={this.state.dtoData.fechainicio}
                                                        name="fechainicio"
                                                        id="fechainicio"
                                                        onChange={this.handleSelectChange}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={2}>
                                                <FormGroup>
                                                    <Label for="fechafin">Fecha fin*</Label>
                                                    <Datepicker
                                                        value={this.state.dtoData.fechafin}
                                                        name="fechafin"
                                                        id="fechafin"
                                                        onChange={this.handleSelectChange}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={2}>
                                                <FormGroup>
                                                    <Label for="duracion">Horas*</Label>
                                                    <Input type="number" min="0.5" step="0.1" value={new Number(this.state.dtoData.duracion)} name="duracion" onChange={this.handleChange} />
                                                </FormGroup>
                                            </Col>

                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="certificadopor">Certificado Emitido Por*</Label>
                                                    <Input required maxLength="150" name="certificadopor" id="certificadopor" value={this.state.dtoData.certificadopor} onChange={this.handleChange} />
                                                </FormGroup>
                                            </Col>

                                            <Col md={3}>
                                                <Label for="fechagraduacion">Evidencia*</Label>
                                                <FormGroup row>

                                                    <Col md={(this.descargarEvidencias(this.state.dtoData).length > 0 ? 10 : 12)}>
                                                        {this.state.filesData.length === 0 &&
                                                            <InputFileUpload
                                                                icon="upload"
                                                                onChange={this.handleFileUploadChange}
                                                                name="EAC"
                                                                placeholder={"Subir Certificado de capacitación"}

                                                            />
                                                        }
                                                        {this.state.filesData.length > 0 &&
                                                            <InputFileUpload
                                                                icon="upload"
                                                                onChange={this.handleFileUploadChange}
                                                                name="EAC"
                                                                placeholder={this.state.dtoData.refarchivo1 !== "" ? "Actualizar Certificado de capacitación" : "Subir Certificado de capacitación"}

                                                            />
                                                        }

                                                    </Col>
                                                    <InputFileDownload tipo="certificado de capacitación"
                                                        id="downloadRef1"
                                                        refarchivo={this.state.dtoData.refarchivo1}
                                                        name={"EAC" + this.state.dtoData.idpersona + ".PDF"}
                                                        url={API_URL + "DatosCapacitacion/Refarchivo/EAC/" + this.state.dtoData.idcapacitacion}
                                                    />
                                                </FormGroup>
                                            </Col>

                                        </Row>
                                        <Row form>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Button color="primary" type="button" className="btn btn-default" style={{ float: "right" }} onClick={() => this.onClickLimpiar()}>Limpiar</Button>
                                                    <Button color="secondary" type="submit" className="btn btn-default" style={{ float: "right" }}>Guardar</Button>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </form >
                                </div>
                                <br />
                                <div>
                                    {(this.state.loadingList ?
                                        <div style={{ textAlign: "center" }}>
                                            <i className="fas fa-sync fa-spin"></i>
                                            <em> Cargando</em>

                                        </div>
                                        :

                                        <Tabs defaultActiveKey="experienciaESPOL">
                                            <Tab eventKey="experienciaESPOL" title="IMPARTIDAS">
                                                <Row id="lista">
                                                    {
                                                        CapacitacionesImpartidasDataList.map((dto, index) =>
                                                            <CardCapacitaciones
                                                                key={dto.idcapacitacion}
                                                                nombre={dto.nombre}
                                                                strNombreTipoEvento={dto.strNombreTipoEvento}
                                                                strRol={dto.strRol}
                                                                strNombrePais={dto.strNombrePais}
                                                                fechainicio={dto.fechainicio}
                                                                fechafin={dto.fechafin}
                                                                duracion={dto.duracion}
                                                                evidencias={this.descargarEvidencias(dto)}
                                                                number={(index + 1) + " / " + CapacitacionesImpartidasDataList.length}
                                                                eventEdit={() => this.onClickEdit(dto.idcapacitacion)}
                                                                eventDelete={() => this.onClickDelete(dto.idcapacitacion)} />

                                                        )
                                                    }
                                                </Row>
                                            </Tab>
                                            <Tab eventKey="experienciaOtras" title="RECIBIDAS">
                                                <Row id="lista">
                                                    {
                                                        CapacitacionesRecibidasDataList.map((dto, index) =>
                                                            <CardCapacitaciones
                                                                key={dto.idcapacitacion}
                                                                nombre={dto.nombre}
                                                                strNombreTipoEvento={dto.strNombreTipoEvento}
                                                                strRol={dto.strRol}
                                                                strNombrePais={dto.strNombrePais}
                                                                fechainicio={dto.fechainicio}
                                                                fechafin={dto.fechafin}
                                                                duracion={dto.duracion}
                                                                evidencias={this.descargarEvidencias(dto)}
                                                                number={(index + 1) + " / " + CapacitacionesRecibidasDataList.length}
                                                                eventEdit={() => this.onClickEdit(dto.idcapacitacion)}
                                                                eventDelete={() => this.onClickDelete(dto.idcapacitacion)} />

                                                        )
                                                    }
                                                </Row>
                                            </Tab>

                                        </Tabs>

                                    )}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </>
        );
    }
}

export default Capacitaciones;